import { render, staticRenderFns } from "./BookMe.vue?vue&type=template&id=8365b17a&scoped=true&"
import script from "./BookMe.vue?vue&type=script&lang=js&"
export * from "./BookMe.vue?vue&type=script&lang=js&"
import style0 from "./BookMe.vue?vue&type=style&index=0&id=8365b17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8365b17a",
  null
  
)

export default component.exports